import { useTranslation } from 'react-i18next';

import emailSuccess from '../../../../assets/auth/email_success_v2.webp';
import Button from '../../../../components/buttons/Button';
import { DialogContent } from '../../../../components/Dialog/DialogUiRedesign/DialogContent';

import styles from './EmailVerificationSuccessStaticContent.module.scss';

interface Props {
  onClose: () => void;
}

export function EmailVerificationSuccessStaticContent({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <DialogContent className={styles.container}>
      <div className={styles.box}>
        <span className={styles.title} data-testid="signup-success-message">
          {t('dialogs.successLowerCase')}
        </span>
        <span className={styles.text}>{t('auth.emailVerifiedSuccessfully')}</span>
      </div>
      <img alt="" className={styles.image} src={emailSuccess} />
      <Button btnType="main" data-testid="signup-close-success-message-button" onClick={onClose}>
        {t('common.close')}
      </Button>
    </DialogContent>
  );
}
